<div class="error-page">
    <empty-state
      [img]="'./assets/images/401ErrorUnauthorized-pana.svg'"
      [title]="'general.Not Authorized' | translate"></empty-state>
  </div>
  